import type { SVGProps } from 'react'
const LineApps = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M12 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m5-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2-9a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-2 16a2 2 0 1 0 0-4 2 2 0 0 0 0 4M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m2 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineApps }
